import globModules from './glob-modules';

const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { render } = require('react-dom');

  nodeList.forEach(node => render(<Component {...node.dataset} />, node));
};

export default [
  ...globModules,
  {
    name: 'defaultVideo',
    loader: () => import('./modules/defaultVideo')
  },
  {
    name: 'flexibleCarousel',
    loader: () => import('./modules/flexibleCarousel')
  },
  {
    name: 'footerSignupForm',
    loader: () => import('./modules/footerSignupForm')
  },
  {
    name: 'logoRow',
    loader: () => import('./modules/logoRow')
  },
  {
    name: 'visualStoryRow',
    loader: () => import('./modules/visualStoryRow')
  },
  {
    name: 'tabbedCarousel',
    loader: () => import('./modules/tabbedCarousel')
  },
  {
    name: 'upCards',
    loader: () => import('./modules/upCards')
  },
  {
    name: 'featuredVerticalCards',
    loader: () => import('./modules/featuredVerticalCards')
  },
  {
    name: 'hero',
    loader: () => import('./modules/hero')
  },
  {
    name: 'alertBanner',
    loader: () => import('./modules/alertBanner')
  },
  {
    name: 'genericRow',
    loader: () => import('./modules/genericRow')
  },
  {
    name: 'headerInteractiveMap',
    loader: () => import('./modules/interactiveMap')
  },
  {
    name: 'lodgingDetail',
    loader: () => import('./modules/legacy/lodgingDetail')
  },
  {
    name: 'emailSignupForm',
    loader: () => import('./modules/legacy/emailSignupForm')
  },
  {
    name: 'richText',
    loader: () => import('./modules/legacy/richText')
  },
  {
    name: 'buttonLink',
    loader: () => import('./modules/legacy/buttonLink')
  },
  {
    name: 'countdownClock',
    loader: () => import('./modules/legacy/countdownClock')
  },
  {
    name: 'navis',
    loader: () => import('./modules/legacy/navis')
  },
  {
    name: 'imageCarousel',
    loader: () => import('./modules/legacy/imageCarousel')
  },
  {
    name: 'roundshotMountainCam',
    loader: () => import('./modules/legacy/roundshotMountainCam')
  },
  {
    name: 'roundshotMountainMap',
    loader: () => import('./modules/legacy/roundshotMountainMap')
  },
  {
    name: 'videoCam',
    loader: () => import('./modules/legacy/videoCam')
  },
  {
    name: 'complexEvents',
    loader: () => import('./modules/legacy/complexEvents')
  },
  {
    name: 'eventFinder',
    loader: () => import('./modules/legacy/eventFinder')
  },
  {
    name: 'sectionSnapshot',
    loader: () => import('./modules/legacy/sectionSnapshot')
  },
  {
    name: 'lodgingSearch',
    loader: () => import('./modules/legacy/lodgingSearch')
  },
  {
    name: 'customForm',
    loader: () => import('./modules/legacy/customForm')
  },
  {
    name: 'smartRecruiterAlerts',
    loader: () => import('./modules/legacy/smartRecruiterAlerts')
  },
  {
    name: 'resyButton',
    loader: () => import('./modules/legacy/resyButton')
  },
  {
    name: 'ticketsForm',
    loader: () => import('./modules/ticketsForm')
  },
  {
    name: 'summerTrailsReport',
    loader: () => import('./modules/legacy/summerTrailsReport')
  },
  {
    name: 'parkingReport',
    loader: () => import('./modules/legacy/parkingReport/index'),
    render: reactModule
  },
  {
    name: 'liftStatusReport',
    loader: () => import('./modules/legacy/liftStatusReport/index'),
    render: reactModule
  },
  {
    name: 'weatherReport',
    loader: () => import('./modules/legacy/weatherReport/index'),
    render: reactModule
  },
  {
    name: 'weatherReportUpdate',
    loader: () => import('./modules/legacy/weatherReportUpdate/index'),
    render: reactModule
  },
  {
    name: 'interactiveMap',
    loader: () => import('./modules/legacy/interactiveMap/index'),
    render: reactModule
  },
  {
    name: 'locationMap',
    loader: () => import('./modules/legacy/locationMap'),
    render: reactModule
  },
  {
    name: 'headerSearch',
    loader: () => import('./modules/headerSearch/index'),
    render: reactModule
  },
  {
    name: 'filterContentModule',
    loader: () => import('./modules/filterContentModule'),
    render: reactModule
  },
  {
    name: 'snowAndTrailReport',
    loader: () => import('./modules/snowAndTrailReport'),
    render: reactModule
  },
  {
    name: 'snowmassStats',
    loader: () => import('./modules/snowmassStats'),
    render: reactModule
  },
  {
    name: 'bookingWidget',
    loader: () => import('./modules/bookingWidget/index'),
    render: reactModule
  },
  {
    name: 'searchResults',
    loader: () => import('./modules/searchResults/index'),
    render: reactModule
  },
  {
    name: 'snowReportSignup',
    loader: () => import('./modules/snowReportSignup'),
    render: reactModule
  },
  {
    name: 'groomingReport',
    loader: () => import('./modules/groomingReport/index'),
    render: reactModule
  },
  {
    name: 'weatherWidget',
    loader: () => import('./modules/weatherWidget/index'),
    render: reactModule
  },
  {
    name: 'exploreAllFour',
    loader: () => import('./modules/exploreAllFour')
  },
  {
    name: 'mapboxMap',
    loader: () => import('./modules/mapboxMap/index')
  },
  {
    name: 'jumplinks',
    loader: () => import('./modules/jumplinks/index'),
    render: reactModule
  },
  {
    name: 'interiorHero',
    loader: () => import('./modules/interiorHero')
  },
  {
    name: 'shareSocialMedia',
    loader: () => import('./components/shareSocialMedia')
  },
  {
    name: 'storyHero',
    loader: () => import('./modules/storyHero')
  },
  {
    name: 'imageGallery',
    loader: () => import('./modules/imageGallery')
  },
  {
    name: 'snowMessaging',
    loader: () => import('./modules/snowMessaging')
  },
  {
    name: 'headerCart',
    loader: () => import('./components/headerCart')
  },
  {
    name: 'liftTickets',
    loader: () => import('./modules/liftTickets'),
    render: reactModule
  },
  {
    name: 'eventListingHero',
    loader: () => import('./modules/eventListingHero')
  },
  {
    name: 'featuredEvents',
    loader: () => import('./modules/featuredEvents')
  },
  {
    name: 'eventListing',
    loader: () => import('./modules/eventListing/index'),
    render: reactModule
  },
  {
    name: 'sitecoreForm',
    loader: () => import('./modules/sitecoreForm')
  },
];
